import React from 'react';
import { Box, Button, Dialog, Grid, IconButton } from '@mui/material';
import Text from './Text';
import { pink } from '@mui/material/colors';
import theme from '../../theme';
import Images from '../../services/data/images';
import CloseIcon from '@mui/icons-material/Close';

interface Props {
  show?: boolean;
  onClose?: () => void;
}

const AppModal: React.FC<Props> = ({ show = false, onClose }) => {
  return (
    <Dialog onClose={onClose} open={show}>
      <Box sx={{ width: '300px', padding: '15px', borderRadius: '16px' }}>
        <Grid container justifyContent="flex-end">
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Grid>
        <Grid
          direction="column"
          container
          alignItems="center"
          gap={2}
          paddingBottom={theme.spacing(2)}
        >
          <Box
            component="img"
            src={Images.bar}
            sx={{ width: '200px', height: '190px' }}
          ></Box>
          <Text>Get the RenoMate app</Text>
          <Text sx={{ textAlign: 'center' }}>
            Scan the QR code with your mobile to download the app for FREE and
            check out the <span style={{ color: pink[400] }}>Sharpie wall</span>{' '}
            project.
          </Text>
          <Button href="https://renomate.app/" color="info" variant="contained">
            Go to RenoMate website
          </Button>
        </Grid>
      </Box>
    </Dialog>
  );
};
export default AppModal;
